import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'whatwg-fetch';
import Partials from '../partials';

const propTypes = {
    blocks: PropTypes.array,
    id: PropTypes.number,
};

const defaultProps = {
    blocks: [],
    id: null,
};

class HubLayout extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pages: null,
        };
    }

    componentDidMount() {
        this.fetchNews();
    }

    fetchNews() {
        const { id } = this.props;
        fetch(`/api/pages/${id}/children`)
            .then(response => response.json())
            .then((pages) => {
                this.setState({
                    pages,
                });
            });
    }

    render() {
        const { blocks } = this.props;
        const { pages } = this.state;
        if (pages === null) {
            return null;
        }
        const pageBlocks = blocks || [];
        const leftBlocks = [];
        const firstTextBlock = pageBlocks.find(block => block.type === 'text') || null;
        if (firstTextBlock !== null) {
            leftBlocks.push(firstTextBlock);
        }
        leftBlocks.push({
            id: 2,
            type: 'logo',
        });
        pageBlocks.forEach((block) => {
            if (block.type !== 'slides' && (firstTextBlock === null || block.id !== firstTextBlock.id)) {
                leftBlocks.push(block);
            }
        });

        const slides = pageBlocks.filter(block => block.type === 'slides');

        return (
            <div className="layout layout-with-cols layout-home">
                <div className="cols">
                    <div className="col col-half">
                        <Partials.Block blocks={leftBlocks} />
                        <Partials.Subpages pages={pages || []} />
                    </div>
                    <div className="col col-half">
                        <div className="col-inner">
                            <Partials.Block blocks={slides} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HubLayout.propTypes = propTypes;
HubLayout.defaultProps = defaultProps;

export default HubLayout;



// WEBPACK FOOTER //
// ./components/layouts/HubLayout.jsx